export const SET_DELIVERY_OPTIONS = 'SET_DELIVERY_OPTIONS';



// WEBPACK FOOTER //
// ./src/actions/types.js